import type { StyleTemplateWithUrls } from 'schemas';
import { StyleTemplatesApiResponseSchema } from 'schemas';
import { apiRequest } from '@/api/helpers/apiRequest';
import { handleApiError } from '@/api/helpers/handleApiError';

export const fetchStyleTemplates = async (): Promise<
  StyleTemplateWithUrls[]
> => {
  try {
    return await apiRequest(
      'GET',
      '/api/style-templates',
      undefined,
      StyleTemplatesApiResponseSchema
    );
  } catch (error) {
    handleApiError(error);
  }
};
